"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _config = require("./config");

var _default = function _default(item) {
  var serviceId = (0, _config.getConfig)().serviceId;

  if (item.serviceId) {
    return item.serviceId === serviceId;
  } else if (item.metric) {
    return item.tags['service.id'] === serviceId;
  }

  return false;
};

exports.default = _default;